
import './App.css';

import States from './Components/States/States';


function App() {
  return (
    
   <div className='App'>
    <States></States>
   </div>
    
  );
}

export default App;
